










import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  name: "WidgetLayout",
  components: {}
})
export default class WidgetLayout extends Vue {
  @Prop({
    default: false
  })
  private required!: boolean;
}
